import React, { createContext, useState } from 'react';

import Axiosfetch from './Axiosfetch';
import baseURL from '../Common/Config';
import moment from 'moment';

const UserDetails =
{
    UserName: '',
    Password: '',
    Authenticate: false,
    AuthMessage: '',
    Role: 0
}

export const AuthDataContext = createContext();

const AuthenticateUser = (props) => {
    const [userdetail, setuserDetails] = useState(UserDetails);

    const onLogin = (postData) => {
        Axiosfetch(baseURL + "ValidateUser", "POST", postData, Succeed, failure);
    };

    const GetTermsAndCondition = (OrgID) => {
        Axiosfetch(baseURL + "GetCompanyInfoByOrgID", "POST", { OrganizationID: OrgID }, companyInfoSuccess, failure);
    };

    const companyInfoSuccess = (data) => {
        if (data.length > 0) {
            localStorage.removeItem("CompanyInfo");
            localStorage.setItem("CompanyInfo", JSON.stringify(data[0]));
        }

        FetchLogo();
    };

    const FetchLogo = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        if (userData) {
            Axiosfetch(baseURL + "GetOrganizationLogo", "POST", { fileName: userData.Organization[0].Logo }, logoInfoSuccess, failure);
        }
    };

    const logoInfoSuccess = (data) => {
        if (data.success && data.fileData !== null) {
            localStorage.setItem("CompanyLogo", data.fileData);
        }
    };

    const Succeed = (data) => {
        if (data.userData.length > 0) {
            var user = data.userData[0];
            if ((user.ExpiryDate !== undefined && user.ExpiryDate !== "" && moment() < moment(user.ExpiryDate)) || (user.Role.length > 0 && user.Role[0].Name.toUpperCase() === "ADMIN")) {
                localStorage.setItem("userData", JSON.stringify(user));
                localStorage.setItem("tokenheader", "Bearer " + data.token);
                GetTermsAndCondition(user.OrganizationID);
                setuserDetails({ ...userdetail, Authenticate: true, UserName: user.FirstName + " " + user.LastName, AuthMessage: "", Role: user.Role._id })
            }
            else {
                setuserDetails({
                    ...userdetail, Authenticate: false, Password: '', UserName: '',
                    AuthMessage: 'License Expired'
                })
            }
        }
        else {
            setuserDetails({
                ...userdetail, Authenticate: false, Password: '', UserName: '',
                AuthMessage: 'Invalid User Name / Passowrd'
            })
        }
    };

    const failure = (err) => {
        setuserDetails({
            ...userdetail, Authenticate: false, Password: '', UserName: '',
            AuthMessage: 'Application Error'
        })
    }

    const OnLicensefailure = () => {
        setuserDetails({
            ...userdetail, Authenticate: false, Password: '', UserName: '',
            AuthMessage: 'License has Expired'
        })
    }

    const onLogout = () => {
        localStorage.setItem("userData", null);
        localStorage.removeItem("userData");
        localStorage.removeItem("tokenheader");
        localStorage.removeItem("CompanyInfo");
        setuserDetails(UserDetails)
    }

    const contextData = {
        login: onLogin,
        logout: onLogout,
        licensefailure: OnLicensefailure,
        userData: userdetail
    }
    return (<AuthDataContext.Provider value={contextData} {...props} ></AuthDataContext.Provider>);
};

export default AuthenticateUser;